import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const BlurbContainerDiv = styled(BaseStyles.Div)`
    padding: 1.2rem 2rem;
`

export const BlurbContainerContentsDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;      
`

export const BlurbContentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;   
    background-color: #383838;
    border-radius: 1.5rem;
    padding: 1.2rem;
`
export const BlurbSectionHeader = styled(BaseStyles.SectionHeader)`
    color: white;
`


export const BlurbDescription = styled(BaseStyles.Description)`
    font-size: 1.4rem;
    color: white;
`
